define('app/components/race/raceController.js',[], function() {
	function driversController($scope, $routeParams, $timeout, $window) {
		
		$scope.raceSelected = true;

		if ( !app ) {
			app = getQlikApp();
			gapp = app;
		}

		app.clearAll();

		$scope.rankChart = {year: null};

		$scope.initialized = false;

		app.createGenericObject({
			latestRaceName: {
				qStringExpression: '=FirstSortedValue([races.name], -[raceId])'
			}
		}, function(reply) { 
			app.destroySessionObject(reply.qInfo.qId);
			app.field('[races.name]').selectMatch(reply.latestRaceName).then(function() {
				$scope.initialized = true;
			})
		 app.field('[races.name]', 'rankChartState').selectMatch(reply.latestRaceName);
		 app.field('[races.name]').lock();
		});

		$scope.qIds = [];

		//RACE SELECTION
		app.createList({
			qDef: {
				qFieldDefs: ['[races.name]'],
				qSortCriterias: [{qSortByAscii: 1}]
			},
			qInitialDataFetch: [{
				qHeight: 900
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.raceNames = _.flatten(reply.qListObject.qDataPages[0].qMatrix);
		});
		$scope.selectRace = function (race) {
			app.field('[races.name]').selectMatch(race);
			app.field('[races.name]', 'rankChartState').selectMatch(race);
			app.field('[races.name]').lock();
			$scope.resetRankChartYear();
		}
		$scope.differentRace = function () {
			app.field('[races.name]').unlock();
			app.field('[races.name]').clear();
		}

		//POLE POSITION CHART STUFF
		app.createGenericObject({
			lapData: {
				qHyperCubeDef: {
					qDimensions: [{
						qDef: {
							qFieldDefs: ["lap"],
							qSortCriterias: [{
								qSortByNumeric: 1
							}]
						}
					}, {
						qDef: {
							qFieldDefs: ["drivername"],
							qSortCriterias: [{
								qSortByAscii: 1
							}]
						}
					}, {
						qDef: {
							qFieldDefs: ["position"],
							qSortCriterias: [{
								qSortByAscii: 1
							}]
						}
					}],
					qInterColumnSortOrder: [0, 2, 1],
					qInitialDataFetch: [{
						qWidth: 3,
						qHeight: 2000
					}],
					qStateName: 'rankChartState' 
				}
			},

		}, function(reply) {
			var lapData = reply.lapData.qHyperCube.qDataPages[0].qMatrix;
			$scope.rankData = {lapData: lapData};
		});

		app.createList({
			qDef: {
				qFieldDefs: ["=if([races.name]='$(vRaceName)', year)"], //=if([races.name]='$(vRaceName)', year)
				qSortCriterias: [{qSortByNumeric: -1}]
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 100
			}],
			qStateName: 'rankChartState'
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var raceYears = _.flatten(reply.qListObject.qDataPages[0].qMatrix);
			$scope.polePositionYears = raceYears.filter(function(year) { return year.qNum > 2010 }).map(function(year) { return year.qNum });
		});
		
		$scope.changeRankChartYear = function () {
			//$scope.rankChart.year = year;
			if ($scope.rankChart.year === null) {
				app.field("year", "rankChartState").clear();
			} else {
				app.field("year", "rankChartState").selectValues([Number($scope.rankChart.year)], false, false);
			}
		}

		$scope.resetRankChartYear = function() {
			$scope.rankChart.year = null;
			app.field("year", "rankChartState").clear();
		}


		//races values
		$scope.raceData = {};
		var fastestTimeExpression = 'Time(Min(Aggr(FirstSortedValue( distinct [results.time], resultId), year)), \'h:mm:ss.fff\')';
		var fastestTimeDriverExpression = 'FirstSortedValue( {1<[results.time] = {"$(=Time(Min(Aggr(FirstSortedValue( distinct [results.time], resultId), year)), \'h:mm:ss.fff\'))"} >} distinct drivername, resultId)';
		var fastestTimeYearExpression = 'FirstSortedValue( {1<[results.time] = {"$(=Time(Min(Aggr(FirstSortedValue( distinct [results.time], resultId), year)), \'h:mm:ss.fff\'))"} >} distinct year, resultId)';
		app.createGenericObject({
			name: {
				qStringExpression: "Only(DISTINCT [races.name])"
			},
			fastestTime: {
				qStringExpression: fastestTimeExpression
			},
			fastestDriver: {
				qStringExpression: fastestTimeDriverExpression
			},
			fastestYear: {
				qStringExpression: fastestTimeYearExpression
			},
			winsDriver: {
				qStringExpression: "if(len(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)))>1,if(right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)),1)=left(right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)),2),1),	SubStringCount(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)),right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)),1))&' drivers tied',FirstSortedValue(drivername, -Aggr(Count({$<[results.position]={1}>} [results.position]), drivername))),FirstSortedValue(drivername, -Aggr(Count({$<[results.position]={1}>} [results.position]), drivername)))"
			},
			winsDriverCount: {
				qStringExpression: "Max(Aggr(Count({$<[results.position]={1}>} [results.position]), drivername))"
			},
			winsConstructor: {
				qStringExpression: "if(len(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])))>1,if(right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])),1)=left(right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])),2),1),	SubStringCount(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])),right(concat(Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])),1))&' constructors tied',FirstSortedValue([constructors.name], -Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name]))),FirstSortedValue([constructors.name], -Aggr(Count({$<[results.position]={1}>} [results.position]), [constructors.name])))" 
			},
			winsConstructorCount: {
				qStringExpression: "Max(Aggr(Count({$<[results.position]={1}>} [results.position]), constructors.name))"
			},
			numOfCircuits: {
				qStringExpression: "Count( {$<[$(=Concat({1<$Field-={'races.name'}>}distinct $Field,']=,[')&']=')>} [circuits.name])"
			},
			firstYear: {
				qStringExpression: "Min( {$<[$(=Concat({1<$Field-={'races.name'}>}distinct $Field,']=,[')&']=')>} year)"
			}
		}, function (reply) {
			$scope.raceData.name = reply.name;
			$scope.raceData.fastestTime = reply.fastestTime;
			$scope.raceData.fastestDriver = reply.fastestDriver;
			$scope.raceData.fastestYear = reply.fastestYear;
			$scope.raceData.numOfCircuits = reply.numOfCircuits;
			$scope.raceData.firstYear = reply.firstYear;
			$scope.raceData.winsDriver = reply.winsDriver;
			$scope.raceData.winsDriverCount = reply.winsDriverCount;
			$scope.raceData.winsConstructor = reply.winsConstructor;
			$scope.raceData.winsConstructorCount = reply.winsConstructorCount;
		});

		//circuits table data
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['year'],
					qSortCriterias: [{qSortByNumeric: -1}]
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Only(circuits.name)'
				}
			}, {
				qDef: {
					qDef: 'Max(laps)'
				}
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInitialDataFetch: [{
				qHeight: 100,
				qWidth: 3
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				if(row[0].qText !== "-" && row[1].qText !== "-" && row[2].qText !== "-") {
					var obj = {
						year: row[0].qText,
						circuit: row[1].qText,
						laps: row[2].qText
					};
					data.push(obj);
				}
			});
			$scope.circuitTableData = data;
		});

		//wins table data
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['year'],
					qSortCriterias: [{qSortByNumeric: -1}]
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'FirstSortedValue({<[drivername]=>}DISTINCT drivername, resultId)'
				}
			}, {
				qDef: {
					qDef: 'FirstSortedValue({<[drivername]=>}DISTINCT [results.time], resultId)'
				}
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInitialDataFetch: [{
				qHeight: 100,
				qWidth: 3
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				if(row[0].qText !== "-" && row[1].qText !== "-" && row[2].qText !== "-") {
					var obj = {
						year: row[0].qText,
						name: row[1].qText,
						time: row[2].qText
					};
					data.push(obj);
				}
			});
			$scope.winsTableData = data;

		});

		//race wins chart
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['=$(vDriverConstructor)']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Count( {$<[results.position]={1}>} [results.position])'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.winsChartData = data;
		});

		//driver percents
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[drivername]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: '=$(vDriverPct)'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.driverPercents = data;
		});

		//by country
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[Driver Country Code]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Count(DriverChampionFlag)'
				},
				qSortBy: {
	              qSortByNumeric: -1,
	            }
			}],
			//qSuppressZero: true,
			qSuppressMissing: true,
			qInterColumnSortOrder: [1,0],
			qInitialDataFetch: [{
				qHeight: 1000,
				qWidth: 2
			}]
		}, function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var data = [];
			qMatrix.forEach(function(row, i) {
				var obj = {
					name: row[0].qText,
					val: row[1].qNum
				};
				data.push(obj);
			});
			$scope.byCountry = data;
		});

		/********* FILTERS ******/
		app.createList({
			qDef: {
				qFieldDefs: ["[races.name]"],
				qSortCriterias: [{qSortByAscii: 1}]
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 100
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			//reply.qListObject.qDimensionInfo.qFallbackTitle = "year";
			$scope.raceFilter = reply.qListObject;
		});

		app.createList({
			qDef: {
				qFieldDefs: ["year"], //=if([races.name]='$(vRaceName)', year)
				qSortCriterias: [{qSortByNumeric: -1}]
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 100
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			reply.qListObject.qDimensionInfo.qFallbackTitle = "year";
			$scope.yearFilter = reply.qListObject;
		});
		app.createList({
			qDef: {
				qFieldDefs: ["[circuits.name]"], //=if([races.name]='$(vRaceName)', [circuits.name])
				qSortCriterias: [{qSortByAscii: 1}]
			},
			qAutoSortByState: {
				qDisplayNumberOfRows: 1
			},
			qShowAlternatives: true,
			qInitialDataFetch: [{
				qHeight: 50
			}]
		}, function (reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.circuitFilter = reply.qListObject;
		});
		/********** END FILTERS *********/

		//Current Selections
		app.getList('SelectionObject', function(reply) {
			if($scope.qIds.indexOf(reply.qInfo.qId) === -1) {
				$scope.qIds.push(reply.qInfo.qId);
			}
			$scope.currentSelections = reply.qSelectionObject.qSelections.filter(function(obj) { return obj.qField !== "races.name"});
			if($scope.currentSelections.length !== reply.qSelectionObject.qSelections.length) {
				var currentRace = reply.qSelectionObject.qSelections.filter(function(obj) { return obj.qField === "races.name"});
				app.variable.setStringValue('vRaceName', currentRace[0].qSelected).then(function() {
					$scope.raceSelected = true;
				});
			} else {
				if ($scope.initialized === true) {
					$scope.raceSelected = false;
				}
			}
		});

		$scope.$on("$routeChangeStart", function() {
			app.field('[races.name]').unlock();
			angular.forEach($scope.qIds, function (qId) {
				app.destroySessionObject(qId);
			});
		});


		//chart heading stuff
		$scope.toggle = function (chart) {
			$scope[chart].showOptions = !$scope[chart].showOptions;
		}
		$scope.blur = function (chart) {
			$timeout(function() {
				$scope[chart].showOptions = false;
			}, 200);
		}

		$scope.winsChart = {
			title: 'DRIVER',
			description: 'The number of championships won by each driver',
			titleOptions: ['DRIVER', 'CONSTRUCTOR'],
			descriptionOptions: ['The number of wins by each driver',
						   'The number of wins by each constructor'],
			valueOptions: ['[drivername]', 
					   '[constructors.name]'],
			variable: 'vDriverConstructor',
			showOptions: false
		};

		$scope.driverPctChart = {
			title: 'CHAMPIONSHIP %',
			description: 'Percentage of championships won based on championships won vs seasons raced',
			titleOptions: ['CHAMPIONSHIP %', 'WIN %', 'PODIUM %', 'POINTS %'],
			descriptionOptions: ['Percentage of championships won based on championships won vs seasons raced',
						   'Percentage of races won based on races won vs races entered',
						   'Percentage of podiums reached based on podiums reached vs races entered',
						   'Percentage of times a driver earned points'],
			valueOptions: ['Count(DriverChampionFlag) / Count(DISTINCT year)', 
					   'Count( {$<[results.position]={1}>} [results.position]) / Count(DISTINCT raceId)',
					   'Count( {$<[results.position]={1,2,3}>} [results.position]) / Count(DISTINCT raceId)',
					   'Count({<[results.points]={">0"}>} [results.points]) / Count(DISTINCT raceId)'],
			variable: 'vDriverPct',
			showOptions: false
		};

		$scope.updateChart = function (chart, i) {
			$scope[chart].title = $scope[chart].titleOptions[i];
			$scope[chart].description = $scope[chart].descriptionOptions[i];
			app.variable.setStringValue($scope[chart].variable, $scope[chart].valueOptions[i]);
		}


		//Filter stuff
		$scope.expandMobileFilters = false;
		$(window).resize(function() {
			if ($(window).width() < 1200) {
				$scope.showCompactFilters = true;
				$scope.showFullFilters = false;
			} else {
				$scope.showCompactFilters = false;
				$scope.showFullFilters = true;
			}
			$timeout(function() {
				$scope.$apply();
			});
		});
		$(window).trigger('resize');

	}

  	driversController.$inject=['$scope','$routeParams', '$timeout', '$window'];

  	return driversController;
});
